// 自动化修改请求地址
let baseUrl = '';
if (process.env.NODE_ENV === "production") {
    baseUrl = 'https://support.seeyon.com';
} else {
    baseUrl = 'https://vprodsupport.seeyon.com';
}

export default{ baseUrl: baseUrl}
